<template>
	<inertia-head title="Join" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h1 class="fw-bold text-white mb-2">Join TRC AI Circle</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Do you want to gain access to the TRC AI Circle? Join now
					</h2>
				</div>
			</div>
		</div>
	</div>

	<!-- AI Circle Benefits -->
	<div class="aic-editorial">
		<div class="aic-editorial__orb aic-editorial__orb--1"></div>
		<div class="aic-editorial__orb aic-editorial__orb--2"></div>
		<div class="aic-editorial__inner">

			<!-- Story section -->
			<div class="aic-story">
				<h2 class="aic-story__heading">The World Is Changing.<br>Are You Ready?</h2>

				<div class="aic-story__divider"></div>

				<p class="aic-story__text">
					Many years ago, cities had lamp-lighters. Their job was simple but important. Every evening, they walked down the streets and lit each lamp post by hand. But when electricity was invented, those jobs slowly disappeared. It wasn't really that electricity replaced people. It simply replaced an old way of working. <strong>The world moved forward.</strong>
				</p>
				<p class="aic-story__text">
					Today we are seeing something similar with AI. Many people fear that AI will replace jobs. But the deeper truth is this: <em class="aic-story__highlight">people who learn to use AI will replace people who don't.</em> The tools are changing, just like electricity changed the lamp posts. And those who learn the new tools will move forward with the world.
				</p>
				<p class="aic-story__text">
					That's why we created the <strong>TRC AI Circle</strong>. It's a place where you can learn how to actually use AI in your work, business, and everyday life — without feeling overwhelmed by the technology.
				</p>
			</div>

			<!-- What you get -->
			<div class="aic-features">
				<h3 class="aic-features__heading">Inside the TRC AI Circle, you'll get:</h3>
				<div class="row g-3 g-lg-4">
					<div class="col-12 col-md-6" v-for="(item, i) in featureItems" :key="i">
						<div class="aic-feature" :style="{ animationDelay: (i * 0.1 + 0.2) + 's' }">
							<span class="aic-feature__icon"><i :class="item.icon"></i></span>
							<p class="aic-feature__text">{{ item.text }}</p>
						</div>
					</div>
				</div>
			</div>

			<!-- Exclusive offer -->
			<div class="aic-exclusive">
				<p class="aic-exclusive__text">
					We're also opening the TRC AI Circle first to all Truly Rich Club members, and as part of the TRC family, you'll be able to join at a <strong>special lower rate</strong> before it becomes widely available to the public.
				</p>
			</div>

			<!-- Closing -->
			<div class="aic-closing">
				<p class="aic-closing__text">
					The goal is simple. Not to turn you into a programmer. But to help you become someone who <strong>knows how to use AI wisely and effectively.</strong>
				</p>
				<p class="aic-closing__cta">
					If you want to stay relevant in a rapidly changing world, come and explore what we're building.
				</p>
			</div>

		</div>
	</div>

	<div class="content">
		<div
			v-if="form.errors.subscription"
			class="alert alert-danger shadow"
			role="alert"
		>
			<h3 class="alert-heading fs-5 fw-bold mb-1">Please choose subscription</h3>
			<p class="mb-0">{{ form.errors.subscription }}</p>
		</div>
		<!-- <div v-if="$page.props.flash && $page.props.flash.title" class="alert" 
			:class="$page.props.flash.title=='Status Success' ? 'alert-success' :'alert-danger'" role="alert"
		>
			<h3 class="alert-heading fs-5 fw-bold mb-1">{{ $page.props.flash.title }}</h3>
			<p class="mb-0">{{ $page.props.flash.message }}</p>
		</div> -->
		<div v-if="!$page.props.flash && pending" class="border border-default p-4 bg-white">
			<h3 class="fs-5 fw-bold mb-1">Transaction Status</h3>
			<p>
				<span v-if="pending.status==null">The transaction is still <span class="text-danger fw-bold">pending</span> and the payment process is not yet complete</span>
				<!-- <span v-else>{{pending.message}}</span> -->
			</p>
			<p class="my-2 fw-bold">
				Below is the details:
			</p>
			<div>
				<p class="my-1">Registered: {{pending.created_at}}</p>
				<p class="my-1">Payment Method: {{pending.mop}}</p>
				<p class="my-1">Subscription: {{pending.subscription}}</p>
			</div>
		</div>
	</div>
	
	<div class="content">
		<div class="row">
			<div class="col-xl-5 col-lg-5">
				<div class="block block-rounded">
					<div class="block-header block-header-default">
						<h3 class="block-title">Choose Subscription</h3>
					</div>
					<div class="block-content block-content-full">
						<div class="row">
							<div
								class="col-12"
								v-for="product in products"
								:key="product.prod_id"
							>
								<div class="form-check form-block mb-3">
									<input
										v-model="form.subscription"
										class="form-check-input"
										type="radio"
										:value="product.prod_id"
										:id="product.prod_id"
										name="subscription"
									/>
									<label class="form-check-label" :for="product.prod_id">
										<span class="d-flex align-items-center">
											<h6 class="fs-sm mb-0">
												{{ product.membership_type }}
											</h6>
											<span
												v-if="product.add_display"
												class="badge bg-warning ms-1"
											>
												{{ product.add_display }}
											</span>
										</span>
										<small>&#8369;{{ product.amount }}</small>
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col">
				<div class="block block-rounded">
					<div class="block-header block-header-default">
						<h3 class="block-title">Choose Payment method</h3>
					</div>
					<div class="block-content block-content-full">
						<form @submit.prevent="joinTRCAiCircle">
							<div class="row">
								<div class="col-12">
									<div class="row">
										<div class="col-6">
											<div class="form-check form-block mb-4">
												<input
													v-model="form.mop"
													class="form-check-input"
													type="radio"
													:value="'CARD'"
													id="card"
													name="mop"
												/>
												<label class="form-check-label" for="card">
													<span
														class="d-flex align-items-center"
														style="
															background-image: url(/media/logo/stripe-logo.png);
															background-size: contain;
															background-repeat: no-repeat;
															background-position: center;
															height: 80px;
														"
													>
													</span>
												</label>
											</div>
										</div>
										<div class="col-6">
											<div class="form-check form-block mb-4">
												<input
													v-model="form.mop"
													class="form-check-input"
													type="radio"
													:value="'DRAGONPAY'"
													id="dragonpay"
													name="mop"
												/>
												<label class="form-check-label" for="dragonpay">
													<span
														class="d-flex align-items-center"
														style="
															background-image: url(/media/logo/dragonpay-logo.png);
															background-size: contain;
															background-repeat: no-repeat;
															background-position: center;
															height: 80px;
														"
													>
													</span>
												</label>
											</div>
										</div>
										<div class="col-6">
											<div class="form-check form-block mb-4">
												<input
													v-model="form.mop"
													class="form-check-input"
													type="radio"
													:value="'DRAGONPAY-GCASH'"
													id="dragonpay_gcash"
													name="mop"
												/>
												<label class="form-check-label" for="dragonpay_gcash">
													<span
														class="d-flex align-items-center"
														style="
															background-image: url(/media/logo/gcash.png);
															background-size: contain;
															background-repeat: no-repeat;
															background-position: center;
															height: 80px;
														"
													>
													</span>
												</label>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div v-if="form.mop == 'CARD'">
								<div v-if="has_card" class="form-check form-switch mb-4">
									<input
										v-model="form.use_existing_card"
										class="form-check-input"
										type="checkbox"
										:value="true"
										id="example-switch-default1"
										name="example-switch-default1"
									/>
									<label class="form-check-label" for="example-switch-default1">
										Use existing card
									</label>
								</div>
								<div v-if="has_card && form.use_existing_card" class="mb-4">
									<p class="mb-0">
										<span class="fw-semibold">CARD:</span>
										<i>**** **** **** {{ card.card_last4 }}</i>
										<span class="badge bg-primary ms-2">{{ card.brand }}</span>
									</p>
								</div>
								<div v-else class="form-group mb-4">
									<stripe @accept-token="acceptToken" ref="stripe" />
									<div v-if="form.errors.card" class="invalid-feedback d-block">
										<i class="fa fa-exclamation-circle"></i>
										{{ form.errors.card }}
									</div>
								</div>
							</div>
							<div class="mb-5">
								<div class="form-floating">
									<input
										type="text"
										class="form-control"
										id="coupon_code"
										v-model="form.coupon_code"
										:class="{ 'is-invalid': form.errors.coupon_code }"
										placeholder="Enter your email"
									/>
									<label class="form-label" for="coupon_code">Coupon Code</label>
									<div v-if="form.errors.coupon_code" class="invalid-feedback">
										<i class="fa fa-exclamation-circle"></i>
										{{ form.errors.coupon_code }}
									</div>
								</div>
							</div>
							<button
								type="submit"
								class="btn btn-lg btn-alt-primary w-100 py-3 fw-semibold"
								:disabled="
									form.processing ||
									!form.isDirty ||
									!form.subscription || 
									(form.mop === 'CARD' && !form.token && !form.use_existing_card)
								"
							>
								<span v-if="!form.processing">Pay Now!</span>
								<span v-else>
									<div class="spinner-border spinner-border-sm text-dark" role="status" >
										<span class="sr-only mr-1">Please wait...</span>
									</div>
									<span class="mx-2">Please wait...</span>
								</span>
							</button>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

import { onMounted, watch } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'
import { useForm } from '@inertiajs/inertia-vue3'
import Stripe from '../../../Shared/Components/Stripe'

export default {
	layout: AuthLayout,
	props: {
		test: String,
		flash: Object,
		products: Object,
		has_card: Boolean,
		card: Object,
		pending: Object,
	},
	components: {
		Stripe,
	},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const form = useForm({
			subscription: null,
			mop: 'CARD',
			pmethod: null,
			pchannel: null,
			token: null,
			use_existing_card: props.has_card ? true : false,
			coupon_code: null,
			test: props.test,
		})

		const acceptToken = (token) => {
			form.token = token
		}

		const joinTRCAiCircle = () => {
			form.post(route('member.trc-ai-circle.post.join'), {
				preserveState: true,
				preserveScroll: true,
			})
		}

		watch(
			() => form.mop,
			(mop) => {
				
				form.pmethod 	= null;
				form.pchannel 	= null;

				if(mop=='CARD' && props.has_card)
				{
					form.use_existing_card = true;
				}else{
					form.use_existing_card = false;
				}

				if(mop!='CARD')
				{
					form.token = null;

					if(mop=='DRAGONPAY-GCASH')
					{
						form.pmethod 	= 'GCASH';
						form.pchannel 	= 'GCSH';
					}
				}
			}
		)

		watch(
			() => form.use_existing_card,
			(use_existing_card) => {
				
				if(use_existing_card==true)
				{
					form.token = null;
				}
			}
		)

		const featureItems = [
			{ icon: 'fa fa-graduation-cap', text: 'Practical lessons on how to use AI tools for productivity, business, and creative work' },
			{ icon: 'fa fa-list', text: 'Step-by-step guides so beginners can learn without a technical background' },
			{ icon: 'fa fa-wrench', text: 'A curated list of useful AI tools you can start using right away' },
			{ icon: 'fa fa-briefcase', text: 'Real examples and workflows you can apply in your daily work' },
			{ icon: 'fa fa-users', text: 'Access to a community that is learning and experimenting with AI together' },
			{ icon: 'fa fa-rocket', text: 'Ongoing updates so you stay ahead as AI evolves' },
		]

		return {
			form,
			joinTRCAiCircle,
			acceptToken,
			featureItems,
		}
	},
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,400;0,600;0,700;1,400;1,600&family=Outfit:wght@400;500;600;700&display=swap');

/* ── Section ─────────────────────────────────── */
.aic-editorial {
	position: relative;
	background: #0b0f1e;
	overflow: hidden;
	padding: 5rem 1.5rem;
}

/* ── Ambient orbs ────────────────────────────── */
.aic-editorial__orb {
	position: absolute;
	border-radius: 50%;
	filter: blur(140px);
	opacity: 0.18;
	pointer-events: none;
}
.aic-editorial__orb--1 {
	width: 600px;
	height: 600px;
	background: radial-gradient(circle, #2563eb 0%, transparent 70%);
	top: -200px;
	left: -150px;
}
.aic-editorial__orb--2 {
	width: 450px;
	height: 450px;
	background: radial-gradient(circle, #7c3aed 0%, transparent 70%);
	bottom: -100px;
	right: -120px;
}

.aic-editorial__inner {
	position: relative;
	z-index: 2;
	max-width: 760px;
	margin: 0 auto;
}

/* ── Story section ───────────────────────────── */
.aic-story {
	margin-bottom: 3.5rem;
	animation: aicFadeIn 0.8s ease both;
}
.aic-story__heading {
	font-family: 'Lora', Georgia, serif;
	font-size: 2.6rem;
	font-weight: 700;
	line-height: 1.2;
	color: #fff;
	margin-bottom: 1.5rem;
	letter-spacing: -0.01em;
	background: linear-gradient(135deg, #fff 30%, #93c5fd 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
}
.aic-story__divider {
	width: 60px;
	height: 3px;
	background: linear-gradient(90deg, #3b82f6, #8b5cf6);
	border-radius: 2px;
	margin-bottom: 2rem;
}
.aic-story__text {
	font-family: 'Outfit', sans-serif;
	font-size: 1.1rem;
	line-height: 1.85;
	color: #b0bec5;
	margin-bottom: 1.5rem;
}
.aic-story__text:last-child {
	margin-bottom: 0;
}
.aic-story__text strong {
	color: #e2e8f0;
	font-weight: 600;
}
.aic-story__highlight {
	color: #93c5fd;
	font-style: italic;
	font-weight: 500;
}

/* ── Features grid ───────────────────────────── */
.aic-features {
	margin-bottom: 3.5rem;
	animation: aicFadeIn 0.8s ease 0.2s both;
}
.aic-features__heading {
	font-family: 'Lora', Georgia, serif;
	font-size: 1.5rem;
	font-weight: 600;
	color: #e2e8f0;
	margin-bottom: 1.75rem;
	padding-bottom: 1rem;
	border-bottom: 1px solid rgba(255,255,255,0.08);
}
.aic-feature {
	display: flex;
	align-items: flex-start;
	gap: 1rem;
	padding: 1.15rem 1.25rem;
	background: rgba(255,255,255,0.03);
	border: 1px solid rgba(255,255,255,0.06);
	border-radius: 0.75rem;
	height: 100%;
	transition: border-color 0.3s ease, background 0.3s ease;
	animation: aicSlideUp 0.6s ease both;
}
.aic-feature:hover {
	border-color: rgba(59,130,246,0.25);
	background: rgba(255,255,255,0.05);
}
.aic-feature__icon {
	flex-shrink: 0;
	width: 40px;
	height: 40px;
	border-radius: 10px;
	background: linear-gradient(135deg, rgba(59,130,246,0.2), rgba(139,92,246,0.2));
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 1rem;
	color: #60a5fa;
}
.aic-feature__text {
	font-family: 'Outfit', sans-serif;
	font-size: 0.95rem;
	line-height: 1.6;
	color: #94a3b8;
	margin: 0;
}

/* ── Exclusive offer ──────────────────────────── */
.aic-exclusive {
	margin-bottom: 2.5rem;
	padding: 1.5rem 2rem;
	background: linear-gradient(135deg, rgba(59,130,246,0.08), rgba(139,92,246,0.08));
	border: 1px solid rgba(96,165,250,0.15);
	border-radius: 0.75rem;
	animation: aicFadeIn 0.8s ease 0.3s both;
}
.aic-exclusive__text {
	font-family: 'Outfit', sans-serif;
	font-size: 1.05rem;
	line-height: 1.8;
	color: #b0bec5;
	margin: 0;
	text-align: center;
}
.aic-exclusive__text strong {
	color: #93c5fd;
	font-weight: 600;
}

/* ── Closing ─────────────────────────────────── */
.aic-closing {
	text-align: center;
	padding-top: 1rem;
	animation: aicFadeIn 0.8s ease 0.4s both;
}
.aic-closing__text {
	font-family: 'Outfit', sans-serif;
	font-size: 1.15rem;
	line-height: 1.8;
	color: #b0bec5;
	max-width: 600px;
	margin: 0 auto 1.25rem;
}
.aic-closing__text strong {
	color: #e2e8f0;
	font-weight: 600;
}
.aic-closing__cta {
	font-family: 'Lora', Georgia, serif;
	font-size: 1.2rem;
	font-weight: 600;
	font-style: italic;
	color: #93c5fd;
	margin: 0;
}

/* ── Animations ──────────────────────────────── */
@keyframes aicFadeIn {
	from { opacity: 0; }
	to { opacity: 1; }
}
@keyframes aicSlideUp {
	from {
		opacity: 0;
		transform: translateY(20px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

/* ── Responsive ──────────────────────────────── */
@media (max-width: 991.98px) {
	.aic-story__heading {
		font-size: 2.1rem;
	}
	.aic-editorial {
		padding: 3.5rem 1.25rem;
	}
}
@media (max-width: 575.98px) {
	.aic-story__heading {
		font-size: 1.75rem;
	}
	.aic-editorial {
		padding: 2.5rem 1rem;
	}
	.aic-story__text {
		font-size: 1rem;
	}
	.aic-features__heading {
		font-size: 1.25rem;
	}
	.aic-feature {
		padding: 1rem;
	}
	.aic-closing__text {
		font-size: 1.05rem;
	}
	.aic-closing__cta {
		font-size: 1.1rem;
	}
}
</style>
